import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import makeStyles from '@material-ui/styles/makeStyles';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import MailOutlineIcon from '@material-ui/icons/MailOutline';

const useStyles = makeStyles(theme => ({
    root: {
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: theme.spacing(2),
        backgroundColor: '#fffaf2'
    },
    card: {
        width: '100%',
        maxWidth: 460,
        padding: theme.spacing(5),
        textAlign: 'center',
        backgroundColor: '#ffffff',
        borderRadius: 16,
        boxShadow: '0 8px 24px rgba(44, 62, 80, 0.08)',
        [theme.breakpoints.down('xs')]: {
            padding: theme.spacing(4, 3)
        }
    },
    iconCircle: {
        width: 72,
        height: 72,
        margin: '0 auto',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '50%',
        backgroundColor: '#fff1db'
    },
    icon: {
        fontSize: 36,
        color: '#f39c12'
    },
    title: {
        marginTop: theme.spacing(3),
        color: '#2c3e50',
        fontWeight: 600
    },
    message: {
        marginTop: theme.spacing(1.5),
        lineHeight: 1.6
    },
    spamNote: {
        marginTop: theme.spacing(3),
        padding: theme.spacing(1.5, 2),
        borderRadius: 8,
        backgroundColor: '#fffaf2',
        color: '#2c3e50'
    },
    signInButton: {
        marginTop: theme.spacing(3)
    }
}));

const SuccessRegistration = () => {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <div className={classes.card}>
                <div className={classes.iconCircle}>
                    <MailOutlineIcon className={classes.icon} />
                </div>
                <Typography className={classes.title} variant="h2">
                    Check your email
                </Typography>
                <Typography className={classes.message} variant="body1" color="textSecondary">
                    Thank you for registering. You will receive an email with a link to activate your account.
                </Typography>
                <Typography className={classes.spamNote} variant="body2">
                    If you do not receive the email, please check your spam folder.
                </Typography>
                <Button
                    className={classes.signInButton}
                    color="primary"
                    component={RouterLink}
                    fullWidth
                    size="large"
                    to="/sign-in"
                    variant="contained"
                >
                    Go to Sign In
                </Button>
            </div>
        </div>
    );
};

export default SuccessRegistration;
